import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const body = new FontFaceObserver('IBM Plex Sans');
	const quote = new FontFaceObserver('IBM Plex Serif');

	Promise.all([body.load(), quote.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
